import { render, staticRenderFns } from "./ConsultantFormActions.vue?vue&type=template&id=404e74d6"
import script from "./ConsultantFormActions.vue?vue&type=script&lang=js"
export * from "./ConsultantFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports